import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'
import type { REPORT_STATUS } from '~/types/report'
import type { ML_LABEL, REVIEW_STATUS } from '~/types/review'

import { ReportStatusBadge, ReviewMlLabelStatusBadge, ReviewStatusBadge, ReviewTopicBadge } from '../../Badges'

import Badge from '~/components/Badge'

export const CustomReviewMlLabelBadgeOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps & { outline?: boolean }): ReactElement => {
  const { value } = data as IOption

  return (
    <div
      className={cx(
        {
          badge: true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <ReviewMlLabelStatusBadge value={value as ML_LABEL} />
    </div>
  )
}

export const CustomReviewStatusBadgeOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps & { outline?: boolean }): ReactElement => {
  const { value } = data as IOption

  return (
    <div
      className={cx(
        {
          badge: true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <ReviewStatusBadge value={value as REVIEW_STATUS} />
    </div>
  )
}

export const CustomReviewTopicBadgeOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps & { outline?: boolean }): ReactElement => {
  const { label } = data as IOption

  return (
    <div
      className={cx(
        {
          badge: true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <ReviewTopicBadge value={label} />
    </div>
  )
}

export const CustomReportStatusBadgeOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps & { outline?: boolean }): ReactElement => {
  const { value } = data as IOption

  return (
    <div
      className={cx(
        {
          badge: true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <ReportStatusBadge value={value as REPORT_STATUS} />
    </div>
  )
}

const CustomBadgeOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
  outline,
}: OptionProps & { outline?: boolean }): ReactElement => {
  const { label } = data as IOption

  return (
    <div
      className={cx(
        {
          badge: true,
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <Badge className="custom-badge-option" outlined={outline} value={label} />
    </div>
  )
}

export default CustomBadgeOption
